import { EventType } from "@/analytics/analytics-events";
import { ToggleRegistrationViewSettingsProperties } from "@/analytics/staging-area-workflows-events-properties";
import {
  FaroMenuProps,
  FaroTooltip,
  ToolButton,
  ViewOptionsIcon,
} from "@faro-lotv/flat-ui";
import { Analytics } from "@faro-lotv/foreign-observers";
import { useState, type JSX } from "react";
import { DataPreparationViewSettingsMenu } from "./data-preparation-view-settings-menu";

export type ViewOptionsToolProps = {
  /** Reference to the element to anchor the popover to */
  anchorEl: FaroMenuProps["anchorEl"];
};

/** @returns a tool button for the ViewSettingsToolbar to manage the data-preparation ViewSettings */
export function DataPreparationViewSettingsTool({
  anchorEl,
}: ViewOptionsToolProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <FaroTooltip placement="left" title="View settings">
        <ToolButton
          aria-label="display view settings"
          onClick={() => {
            Analytics.track<ToggleRegistrationViewSettingsProperties>(
              EventType.toggleRegistrationViewSettings,
              {
                opening: true,
              },
            );
            setIsOpen(true);
          }}
          selected={isOpen}
        >
          <ViewOptionsIcon />
        </ToolButton>
      </FaroTooltip>

      <DataPreparationViewSettingsMenu
        open={isOpen}
        onClose={() => {
          Analytics.track<ToggleRegistrationViewSettingsProperties>(
            EventType.toggleRegistrationViewSettings,
            {
              opening: false,
            },
          );
          setIsOpen(false);
        }}
        anchorEl={anchorEl}
      />
    </>
  );
}
